import Dialog from 'components/common/dialog';
import { Link } from 'components/common/link';
import { Urls } from 'config/urls';
import { useState } from 'react';
import { openNewTabAndFocus } from 'utils';
import styles from './styles.module.scss';
import Parser from 'html-react-parser';
import { useTranslation } from 'react-i18next';

export const TermsAndConditions = () => {
  const { t } = useTranslation();
  const [showTyC, setShowTyC] = useState(false);
  return (
    <div className={styles.terms_and_conditions}>
      {t('termsAndConditions.message.part1')}
      <Link onClick={() => setShowTyC(true)}>{t('termsAndConditions.message.part2')}</Link>
      {t('termsAndConditions.message.part3')}
      <Link onClick={() => openNewTabAndFocus(Urls.externals.customerSupport)}>{t('termsAndConditions.message.part4')}</Link>
      <Dialog dividers={false} open={showTyC} title={t('termsAndConditions.title')} handleClose={() => setShowTyC(false)}>
        <div>{Parser(t('termsAndConditions.content', { 0: process.env.REACT_APP_DOMAIN }))}</div>
      </Dialog>
    </div>
  );
};
